<template>
	<div class="slide-verify" id="slideVerify">
		<!-- 拼图部分 -->
		<div class="verify-box">
			<!-- 重置按钮 -->
			<span class="reset" @click="reset">
			</span>
			<!-- 拼图碎片 -->
			<div class="verify-box-small">
				<img :src="smallPic" alt="" :style="{top : smallY + 'px',left : smallX + 'px'}">	
			</div>
			<!-- 拼图 -->
			<div class="verify-box-big" >
				<img :src="bigPic" alt="">
			</div>
			<!-- 拼图加载占位 -->
			<div class="verify-box-mask" v-show="!this.bigPic">
				加载中...
			</div>
		</div>
		<!-- 拖拉按钮部分 -->
		<div class="slide-verify-slider-mask">
			<div
				@touchstart="Down"
				@mousedown="Down"
				:style="{left: buttonX + 'px'}"
				class="slide-verify-button">
			</div>
		</div>
		<!-- 提示语 -->
		<span class="slide-verify-slider-text" v-show="!isMove">{{sliderText}}</span>
	</div>
</template>
<script>
import { checkimageverifycode, imagecaptcha } from "@/port/pages/login";
import { ElMessage } from 'element-plus'
export default {
	name: 'SlideVerify',
	props: {
		sliderText: {
			type: String,
			default: 'Slide filled right',
		},
		phone: {
			type: String
		}
	},
	data() {
		return {
			bigPic: '',
			smallPic: '',
			smallY: 0,
			smallX: 0,
			isMove: false,
			buttonX: 0,
			downX: 0,
			moveX: 0,
			captchatoken: '',
		}
	},
	mounted() {
		this.getCaptcha()

		this.getImageCaptcha()

		this.addEvent()
	},
	beforeUnmount () {
		this.removeEvent()
	},
	methods: {
		// 绑定事件
		addEvent() {
			window.addEventListener('touchmove', this.Move)
			window.addEventListener('touchend', this.MoveEnd)
			window.addEventListener('mousemove', this.Move)
			window.addEventListener('mouseup', this.MoveEnd)
		},
		// 移除事件
		removeEvent() {
			window.removeEventListener('touchmove', this.Move)
			window.removeEventListener('touchend', this.MoveEnd)
			window.removeEventListener('mousemove', this.Move)
			window.removeEventListener('mouseup', this.MoveEnd)
		},
		//- 获取图片验证码
		getCaptcha () {
			this.captchatoken = (Math.random() * 10).toString().slice(-6);
		},
		// 获取滑块验证码
		getImageCaptcha() {
			let data = {
				imagecaptchatoken: this.captchatoken
			}
			imagecaptcha(data).then(res => {
				this.bigPic = res.data.verifyBigImage
				this.smallPic = res.data.verifySmallImage
				this.smallY = res.data.YHeight/2
			}).catch(error => {
				console.log(error);
			});
		},
		// 验证滑动是否成功
		verify(e){
			let data = {
				imagecaptchatoken: this.captchatoken,
				moveLength: e*2
			}
			checkimageverifycode(data).then(res=>{
				if (res.code === 0) {
					this.$emit('success',data)
				}	else {
					this.reset()
					ElMessage({
					type: 'error',
					message: '验证失败，请重新验证'
					})
					this.$emit('fail', data)
					return false
				}
			}).catch(err=>{
				console.log(err);
			})
		},
		// 点击获取当前鼠标的位置
		Down(e){
			if (e.clientX !== undefined) {
				this.downX = e.clientX
			} else {
				const mobie = e.changedTouches[0]
				this.downX = mobie.clientX
			}
			this.isMove = true
		},
		// 拖动按钮
		Move(e){
			if(!this.isMove) return false
			if (e.clientX !== undefined) {
				this.moveX = e.clientX
			} else {
				const mobie = e.changedTouches[0]
				this.moveX = mobie.clientX
			}
			let temp = this.moveX - this.downX
			if (temp >= 247 || temp < 0) return false
			this.buttonX = temp
			this.smallX = temp
		},
		// 拖动结束
		MoveEnd(){
			if(!this.isMove) return false
			if (this.smallX <= 0) {
				this.reset()
				return false
			}
			this.verify(this.smallX)
		},
		// 拼图复位
		reset(){
			this.bigPic = ''
			this.getImageCaptcha()
			this.buttonX  = 0
			this.smallX  = 0
			this.isMove = false
		}
	}
}
</script>
<style scoped lang='scss'>
	.slide-verify {
		user-select: none;
		position: relative;
		width: 285px;
		.verify-box{
			position: relative;
			width: 100%;
			height: 155px;
			// 重置按钮
			.reset{
				cursor: pointer;
				position: absolute;
				right: 0;
				top: 0;
				background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/icon_light.png') center;
				background-position:-5px 70px;
				width: 26px;
				height: 26px;
				z-index: 999;
			}
			.verify-box-small{
				position: absolute;
				top: 0;
				left: 0;
				width: 39px;
				height: 100%;
				img{
					position: absolute;
					width: 28px;
					height: 24px;
				}
			}
			.verify-box-big{
				border-radius: 10px;
				overflow: hidden;
				img{
					width: 285px;
					height: 154px;
				}
			}
			.verify-box-mask{
				position: absolute;
				left: 0;
				top: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				background-color: #fff;
			}
		}
		.slide-verify-slider-mask{
			position: relative;
			top: 20px;
			width: 100%;
			height: 33px;
			background-color: #E0E1E3;	
			border-radius: 18px;
			.slide-verify-button{
				position: absolute;
				top: -8px;
				cursor: pointer;
				width: 48px;
				height: 48px;
				background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/arr.png') no-repeat center;
				background-color: #fff;
				box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);;
				border-radius: 50%;
			}
		}
		.slide-verify-slider-text{
			position: absolute;
			top: 182px;
			left: 62px;
			display: inline-block;
			z-index: 999;
			color: #999999;
		}
	}
	
</style>
